"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateApplicationFormPage = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
exports.UpdateApplicationFormPage = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 2rem 0 4rem;\n\n  & > form {\n    display: flex;\n\n    & > article {\n      flex: 1;\n    }\n\n    & > aside {\n      margin-left: 1.6rem;\n    }\n  }\n"], ["\n  padding: 2rem 0 4rem;\n\n  & > form {\n    display: flex;\n\n    & > article {\n      flex: 1;\n    }\n\n    & > aside {\n      margin-left: 1.6rem;\n    }\n  }\n"])));
var templateObject_1;
